module.exports = __webpack_public_path__ + "img/03040103.9d7b9aba.jpg";